import React from 'react';
import './Chapters.scss';

function Chapter2() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          How do you tackle these intersecting issues that threaten the health and stability of
          billions of people around the globe?
        </p>

        <p className="chapter__paragraph">
          If you’re Alon Ascher, the answer is autonomy. As Chief Business Officer of Israel-based
          Bluewhite (previously known as Blue White Robotics), Ascher and his team are on a mission
          to build resilient farms by maximizing productivity and reducing operational costs.
        </p>
      </section>
    </>
  );
}

export default Chapter2;
